function etsInstaIsPreviewMode(){
  var url = new URL(window.location.href);
  var previewMode = url.searchParams.get('etsMMPreviewMode');
  if(previewMode)
  {
    return true;
  }
  return false
}
var ETS_MM_CONFIG = {
  navigator: etsInstaIsPreviewMode() ? "306066751626-child-8fbd2509bf5e00fb0b5fb45de56019f8-legacy-lawn" : "306066751626-child-8fbd2509bf5e00fb0b5fb45de56019f8-legacy-lawn",
  use_embeddedcode: etsInstaIsPreviewMode() ? 0 : 0,
  show_class_mobile: etsInstaIsPreviewMode() ? 0 : 0,
  menu_enabled: etsInstaIsPreviewMode() ? 1 : 0
};
